export interface OptionsType {
  label: string;
  value: number | string;
}
export const getConvertedFunctionalityData = (
  data: any,
  language?: string | null | undefined,
) => {
  const LANGUAGE = {
    BANGLA: "bn",
    ENGLISH: "en",
  };

  let convertedData = [] as OptionsType[];
  data &&
    data.forEach((item: any) => {
      let selectOptions = {} as OptionsType;
      selectOptions.label =
        language === LANGUAGE.BANGLA
          ? item.nameBn || item.name_bn || item.bn_name || item.name
          : item.nameEn || item.name_en || item.en_name || item.name;
      selectOptions.value = item.id;

      convertedData.push(selectOptions);
    });

  return convertedData?.sort((a, b) =>
    String(a.label).localeCompare(String(b.label)),
  );
};
